module.exports = [
	{
		"age": "16",
		"thirtyDay": "57.47",
		"sixtyDay": "30.8",
		"ninetyDay": "19.73"
	},
	{
		"age": "17",
		"thirtyDay": "57.47",
		"sixtyDay": "30.89",
		"ninetyDay": "19.95"
	},
	{
		"age": "18",
		"thirtyDay": "57.47",
		"sixtyDay": "31",
		"ninetyDay": "20.13"
	},
	{
		"age": "19",
		"thirtyDay": "58.39",
		"sixtyDay": "31.72",
		"ninetyDay": "20.65"
	},
	{
		"age": "20",
		"thirtyDay": "59.82",
		"sixtyDay": "32.63",
		"ninetyDay": "21.45"
	},
	{
		"age": "21",
		"thirtyDay": "61.38",
		"sixtyDay": "33.64",
		"ninetyDay": "22.17"
	},
	{
		"age": "22",
		"thirtyDay": "63.35",
		"sixtyDay": "34.86",
		"ninetyDay": "23.17"
	},
	{
		"age": "23",
		"thirtyDay": "66.23",
		"sixtyDay": "36.59",
		"ninetyDay": "24.49"
	},
	{
		"age": "24",
		"thirtyDay": "69.12",
		"sixtyDay": "38.41",
		"ninetyDay": "25.82"
	},
	{
		"age": "25",
		"thirtyDay": "72.38",
		"sixtyDay": "40.34",
		"ninetyDay": "27.25"
	},
	{
		"age": "26",
		"thirtyDay": "75.53",
		"sixtyDay": "42.28",
		"ninetyDay": "28.77"
	},
	{
		"age": "27",
		"thirtyDay": "78.67",
		"sixtyDay": "44.32",
		"ninetyDay": "30.29"
	},
	{
		"age": "28",
		"thirtyDay": "82.32",
		"sixtyDay": "46.54",
		"ninetyDay": "32.02"
	},
	{
		"age": "29",
		"thirtyDay": "85.87",
		"sixtyDay": "48.67",
		"ninetyDay": "33.76"
	},
	{
		"age": "30",
		"thirtyDay": "89.52",
		"sixtyDay": "51.01",
		"ninetyDay": "35.47"
	},
	{
		"age": "31",
		"thirtyDay": "95.68",
		"sixtyDay": "54.77",
		"ninetyDay": "38.21"
	},
	{
		"age": "32",
		"thirtyDay": "101.96",
		"sixtyDay": "58.52",
		"ninetyDay": "41.06"
	},
	{
		"age": "33",
		"thirtyDay": "108.78",
		"sixtyDay": "62.59",
		"ninetyDay": "44.1"
	},
	{
		"age": "34",
		"thirtyDay": "115.96",
		"sixtyDay": "66.85",
		"ninetyDay": "47.35"
	},
	{
		"age": "35",
		"thirtyDay": "123.3",
		"sixtyDay": "71.31",
		"ninetyDay": "50.61"
	},
	{
		"age": "36",
		"thirtyDay": "130.08",
		"sixtyDay": "75.39",
		"ninetyDay": "53.75"
	},
	{
		"age": "37",
		"thirtyDay": "137.02",
		"sixtyDay": "79.65",
		"ninetyDay": "56.9"
	},
	{
		"age": "38",
		"thirtyDay": "144.24",
		"sixtyDay": "83.91",
		"ninetyDay": "60.06"
	},
	{
		"age": "39",
		"thirtyDay": "151.3",
		"sixtyDay": "88.08",
		"ninetyDay": "63.29"
	},
	{
		"age": "40",
		"thirtyDay": "158.37",
		"sixtyDay": "92.24",
		"ninetyDay": "66.34"
	},
	{
		"age": "41",
		"thirtyDay": "165.41",
		"sixtyDay": "96.51",
		"ninetyDay": "69.49"
	},
	{
		"age": "42",
		"thirtyDay": "172.75",
		"sixtyDay": "100.77",
		"ninetyDay": "72.63"
	},
	{
		"age": "43",
		"thirtyDay": "179.95",
		"sixtyDay": "104.94",
		"ninetyDay": "75.7"
	},
	{
		"age": "44",
		"thirtyDay": "186.9",
		"sixtyDay": "109",
		"ninetyDay": "78.74"
	},
	{
		"age": "45",
		"thirtyDay": "193.82",
		"sixtyDay": "113.08",
		"ninetyDay": "81.67"
	},
	{
		"age": "46",
		"thirtyDay": "201.93",
		"sixtyDay": "117.73",
		"ninetyDay": "85.04"
	},
	{
		"age": "47",
		"thirtyDay": "210.18",
		"sixtyDay": "122.51",
		"ninetyDay": "88.6"
	},
	{
		"age": "48",
		"thirtyDay": "218.42",
		"sixtyDay": "127.39",
		"ninetyDay": "92.04"
	},
	{
		"age": "49",
		"thirtyDay": "226.78",
		"sixtyDay": "132.15",
		"ninetyDay": "95.6"
	},
	{
		"age": "50",
		"thirtyDay": "235.68",
		"sixtyDay": "137.33",
		"ninetyDay": "99.36"
	},
	{
		"age": "51",
		"thirtyDay": "246.16",
		"sixtyDay": "143.43",
		"ninetyDay": "103.92"
	},
	{
		"age": "52",
		"thirtyDay": "256.76",
		"sixtyDay": "149.73",
		"ninetyDay": "108.59"
	},
	{
		"age": "53",
		"thirtyDay": "268.39",
		"sixtyDay": "156.74",
		"ninetyDay": "113.78"
	},
	{
		"age": "54",
		"thirtyDay": "280.7",
		"sixtyDay": "164.15",
		"ninetyDay": "119.47"
	},
	{
		"age": "55",
		"thirtyDay": "294.16",
		"sixtyDay": "172.27",
		"ninetyDay": "125.65"
	},
	{
		"age": "56",
		"thirtyDay": "308.7",
		"sixtyDay": "181.32",
		"ninetyDay": "132.65"
	},
	{
		"age": "57",
		"thirtyDay": "324.55",
		"sixtyDay": "191.28",
		"ninetyDay": "140.59"
	},
	{
		"age": "58",
		"thirtyDay": "341.94",
		"sixtyDay": "202.44",
		"ninetyDay": "149.43"
	},
	{
		"age": "59",
		"thirtyDay": "361.58",
		"sixtyDay": "215.14",
		"ninetyDay": "159.78"
	},
	{
		"age": "60",
		"thirtyDay": "380.94",
		"sixtyDay": "228.04",
		"ninetyDay": "170.55"
	},
	{
		"age": "61",
		"thirtyDay": "404.74",
		"sixtyDay": "244.18",
		"ninetyDay": "184.05"
	},
	{
		"age": "62",
		"thirtyDay": "431.57",
		"sixtyDay": "259.2",
		"ninetyDay": "193.9"
	},
	{
		"age": "63",
		"thirtyDay": "438.77",
		"sixtyDay": "260.33",
		"ninetyDay": "190.13"
	},
	{
		"age": "64",
		"thirtyDay": "322.45",
		"sixtyDay": "173.49",
		"ninetyDay": "104.84"
	}
];


//////////////////
// WEBPACK FOOTER
// C:/Git/qsuper-fed/~/json-loader!./src/data/standardRateUnitisedTwoYear.json
// module id = 456
// module chunks = 0